import TemplateView from '../../../../TemplateView'
import LicenseCard from './LicenseCard'
import AddUsersCard from './addUsers/AddUsersCard'

export default class LicenseCardsContainer extends TemplateView {
    constructor({
        active,
        trial,
        expired,
        startDate,
        expirationDate,
        daysToExpiration,
        issueDate,
        unlimited,
        allowedUsersCount,
        free,
        currentUsersCount,
        formattedName,
        licensesMonthCount,
        product,
        gracePeriod,
        endDateWithGracePeriod,
        licenseId,
        licenseExpires,
        onPurchaseClick = () => {},
        onCancelButtonClick = () => {},
        onAddUsersButtonClick = () => {},
    }) {
        super()

        this.params = {
            active,
            trial,
            startDate,
            expired,
            expirationDate,
            daysToExpiration,
            issueDate,
            unlimited,
            allowedUsersCount,
            free,
            currentUsersCount,
            formattedName,
            licensesMonthCount,
            product,
            gracePeriod,
            endDateWithGracePeriod,
            licenseId,
            licenseExpires,
        }

        this.callbacks = {
            onPurchaseClick,
            onCancelButtonClick,
            onAddUsersButtonClick,
        }

        this.state = {
            showAddUsersCard: false,
        }

        this.onStatePropertyChanged('showAddUsersCard', (showAddUsersCard) => {
            this.licenseCard.toggle(!showAddUsersCard)
            this.addUsersCard.toggle(showAddUsersCard)
        })
    }

    templateHtml() {
        return '<div class="cardsContainer"/>'
    }

    afterRender() {
        this.licenseCard = new LicenseCard({
            ...this.params,
            onAddUsersButtonClick: this.callbacks.onAddUsersButtonClick
        }).init(this.getEl())

        const isAddUsersAvailable = !this.params.trial && !this.params.free && !this.params.unlimited && !this.params.expired
        if (isAddUsersAvailable) {
            this.addUsersCard = new AddUsersCard({
                ...this.params,
                onCancelButtonClick: this.callbacks.onCancelButtonClick,
                onPurchaseClick: this.callbacks.onPurchaseClick,
            }).init(this.getEl())

            this.addUsersCard.toggle(false)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/LicensesCardsContainer.js